import React from 'react';

import { StyleSheet, Text, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const DialogHeader = ({ title }: { title: string }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.headingText}>{title}</Text>
  </View>
);

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  icon: {
    marginBottom: 8,
  },
  headingText: {
    fontSize: primitive.fontSizes['2xl'],
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    textAlign: 'center',
    color: primitive.bk.$bbqBrown,
  },
});
